<template>
  <div>
    <div class="scenario_part retire-4 scenario_bgs">
      <div class="container">
        <div class="all_wrapper flex">
            <div class="scenario_dialog" key="2" v-if="optionToggle">
              <h2>退休生活真愜意！想多久來一趟國內旅行？</h2>
              <div class="scenario_option">
                <ul>
                  <li>
                    <a href="" @click.prevent="toNext('retire_4','retire_5', 12, '1個月')">
                      <div class="option_img">
                        <img src="@/assets/images/needs/banner-retire/calendar1.svg" alt="">
                      </div>
                      <div class="option_text">
                        <p>1 個月</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="" @click.prevent="toNext('retire_4','retire_5', 4, '3個月')">
                      <div class="option_img">
                        <img src="@/assets/images/needs/banner-retire/calendar3.svg" alt="">
                      </div>
                      <div class="option_text">
                        <p>3 個月</p>
                      </div>
                    </a>
                  </li>
                  <li>
                    <a href="" @click.prevent="toNext('retire_4','retire_5', 2, '半年以上')">
                      <div class="option_img">
                        <img src="@/assets/images/needs/banner-retire/calendar6.svg" alt="">
                      </div>
                      <div class="option_text">
                        <p>半年以上</p>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
        </div>
      </div>
      <ProgressBar :page="page"></ProgressBar>
    </div>
  </div>
</template>

<script>

import GA from "@/func/seo";
import ProgressBar from '@/components/common/progress_bar'

export default {
  name: "retire_4",
  components: {ProgressBar},
  data: function () {
    return {
      optionToggle: true,
      option1: true,
      option2: false,
      page: {
        page_no: 4,
        total: 6,
        isRetire: true
      }
    }
  },
  methods: {
    toNext(from, to, times, option) {
      let optionNo = 'option4_1'
      this.$store.dispatch('retire/addOption', {optionNo, option})
      this.$store.dispatch('retire/setNativeTimes', times)
      store.set('retire/changeShow!', {from, to})
    }
  },
  mounted() {
    GA.pushRetireEvent(4, '多久來一趟國內旅行')
  }
}
</script>

<style scoped>
.scenario_dialog .scenario_option ul li {
  margin: 8px;
  background-color: #fff !important;
  border-radius: 6px !important;
  width: 33.3334%;
  border: 3px solid #fff;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  padding: 0 !important;
}

.scenario_dialog .scenario_option ul li:hover {
  border: 3px solid #000 !important;
}

@media (max-width: 767px) {
  .scenario_dialog .scenario_option ul li {
    margin: 8px 0;
    width: 100%;
  }
}
</style>
